import { useEffect } from "react";

export default function RedirectSpmbLabAdmin() {
  useEffect(() => {
    window.location.href =
      "https://penerimaan-old.undiksha.ac.id/spmb-sekolah-lab/admin";
  }, []);

  return null;
}
